import { AsyncStatus, IAsyncStatus, User } from '../../types';

import actions from './actions';
import reducer from './reducer';
import selectors from './selectors';

export interface UsersStore {
  users: {[key in number]: User };
  status: AsyncStatus;
  // updatingUsers stores the status of pending or completed requests to updated user data.
  updatingUsers: {
    [userId: string]: IAsyncStatus;
  };
}

export default { actions, reducer, selectors };
